// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__3eOgd","inputHolder":"Form_inputHolder__pGJzi","input":"Form_input__21uh-","icon":"Form_icon__2zc6m"};